import BaseSelect from "@/views/crud/modules/BaseSelect.vue";

export default {
  key: "voucher",
  id: "id",
  export: ["excel"],
  excel: {
     //max_row: "50000" 
  },
  sort: {
    field: "id",
    order: "desc"
  },
  sort_fields: [
    "id",
    "memberId",
    "voucherExpireDate",
    "rsrId",
    "address",
    "status",
    "campaignName"
  ],
  filters: {
    id: {},
    memberId: {},
    voucherExpireDate: {type: "daterange"},
    rsrId: {},
    status:{type: "select"},
    address: {},
    campaignName: {},
    campaignId:{type: "select"},
    creUserName: {},

    // creUser: {},
    creDttm: {type: "daterange"},
    lupdDttm: {type: "daterange"},
    // deleteDttm: {type: "daterange"},
    // redeemDttm: {type: "daterange"},
    // locId: {
    //   type: "select",
    //   label: "name_chi",
    //   value: "loc_id",
    // },
  },
  fields: [
    { key: "id", width: 75 ,hidden:["create"],disabled:["edit"]},
    { key: "memberId",disabled:["edit"], width: "10%"},
    { key: "campaignId", type:"componentColumn", component:BaseSelect, multiple:false, filterable:true, closeable:false, optionKey:"campaign", setup:{label:'label',value:'value'} },
    {
      key: "campaignId2",
      type: "href",
      url:"campaign/",
      url_key:[
        {
          search_key:"id",
          row_key:"campaignId",
          str:""
        }
      ],
    },
    { key: "voucherExpireDate", type: "date", width: 120},
    { key: "rsrId",hidden:["create"],disabled:["edit"], width: 120},
    { key: "address",hidden:["create"], width: "15%"},
    {key: "locId", component:BaseSelect, multiple:false, filterable:true, type:"componentColumn", optionKey: "cp_locs", setup:{label:'label',value:'value'}, width: "15%"},
    {key: "faceValue", hidden: ["create", "edit"], width: "5%"},
    { key: "status",hidden:["create"],disabled:["edit"], width: 120},
    { key: "creUserName",hidden:["create"], width: 120},
    { key: "creDttm", type: "datetime" ,hidden:["create"],disabled:["edit"], width: 120},
    { key: "lupdDttm", type: "datetime" ,hidden:["create"],disabled:["edit"], width: 120},
    { key: "deleteDttm", type: "datetime" ,hidden:["create"],disabled:["edit"], width: 120},
    { key: "redeemDttm", type: "datetime" ,hidden:["create"],disabled:["edit"], width: 120},
    { type: "action-btn", width: 40 },
  ],
  structure: [
    ["id","memberId"],
    ["locId"],
    ["campaignId","voucherExpireDate"],
    ["rsrId","status"],
    ["creUser","creDttm"],
    ["lupdDttm","deleteDttm"],
    ["redeemDttm"]
  ],
  action: ["create","delete"],
  // action: ["create","edit","view","delete"],
  options: {
    campaignId: {
      key: "campaign",
      label: "name",
      value: "id"
    },
    status: {
      key: "voucherStatus",
    },
    locId: {
      key: "cp_locs",
      label: "address",
      value: "loc_id"
    },
  },
  view: [
    ["id","memberId"],
    ["campaignId","voucherExpireDate"],
    ["rsrId","status"],
    ["creUser","creDttm"],
    ["lupdDttm","deleteDttm"],
    ["redeemDttm"]
  ],
  extra_components: {
  },
  disabled_by_column:{
    list:[
      {key:"status", val:"Valid", type:"eq"}
    ]
  },
  extra_privillege_components: {
  },
  import: {
    url:"voucher/import",
    demo_url:"Voucher.xlsx",
    fields:[
      {key:"memberId", not_null:true, label:"Member Id"},
      {key:"voucherExpireDate", not_null:true, type:"date", label:"Expire Date (yyyy-mm-dd)"},
      // {key:"campaignName", not_null:true, label:"Campaign"}
    ],
    component:{key:"campaignId", component:BaseSelect, multiple:false, filterable:true, closeable:false, optionKey:"campaign", setup:{label:'label',value:'value', defaultSort:0}},
    component2:{key: "locId", component:BaseSelect, multiple:false, filterable:true, type:"componentColumn", optionKey: "cp_locs", setup:{label:'label',value:'value'}},
  }
}